(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["galerie-personnes-genou"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('n9-knee-slider')) {
    customElements.define(
      'n9-knee-slider',
      class extends HTMLElement {
        connectedCallback() {
          this.frame = requestAnimationFrame(() => this.initialize());
        }

        initialize() {
          if (!this.isConnected || this.controller) return;

          this.track = this.querySelector('.n9-knee-gallery__grid');
          this.controls = this.querySelector('.n9-knee-gallery__controls');
          this.previous = this.querySelector('[data-previous]');
          this.next = this.querySelector('[data-next]');

          if (
            !this.track ||
            !this.controls ||
            !this.previous ||
            !this.next
          ) return;

          this.controller = new AbortController();
          const signal = this.controller.signal;

          this.previous.addEventListener(
            'click',
            () => this.move(-1),
            { signal }
          );

          this.next.addEventListener(
            'click',
            () => this.move(1),
            { signal }
          );

          this.track.addEventListener(
            'scroll',
            () => this.update(),
            { passive: true, signal }
          );

          this.track.addEventListener(
            'keydown',
            event => {
              if (event.target !== this.track) return;

              const direction = this.direction();

              if (
                event.key === 'ArrowRight' ||
                event.key === 'ArrowLeft'
              ) {
                event.preventDefault();

                this.move(
                  (event.key === 'ArrowRight' ? 1 : -1) * direction
                );
              } else if (
                event.key === 'Home' ||
                event.key === 'End'
              ) {
                event.preventDefault();

                this.track.scrollTo({
                  left:
                    event.key === 'Home'
                      ? 0
                      : this.maximum() * direction,
                  behavior: this.behavior()
                });
              }
            },
            { signal }
          );

          document.addEventListener(
            'shopify:block:select',
            event => {
              const card = Array.from(this.track.children).find(
                item => item.dataset.blockId === event.detail?.blockId
              );

              if (!card) return;

              const trackRect = this.track.getBoundingClientRect();
              const cardRect = card.getBoundingClientRect();

              const offset =
                this.direction() === 1
                  ? cardRect.left - trackRect.left
                  : cardRect.right - trackRect.right;

              this.track.scrollBy({
                left: offset,
                behavior: this.behavior()
              });
            },
            { signal }
          );

          this.observer = new ResizeObserver(() => this.update());
          this.observer.observe(this.track);

          this.update();
        }

        disconnectedCallback() {
          cancelAnimationFrame(this.frame);
          this.controller?.abort();
          this.observer?.disconnect();
          this.controller = null;
        }

        direction() {
          return getComputedStyle(this.track).direction === 'rtl'
            ? -1
            : 1;
        }

        maximum() {
          return Math.max(
            0,
            this.track.scrollWidth - this.track.clientWidth
          );
        }

        behavior() {
          return matchMedia(
            '(prefers-reduced-motion: reduce)'
          ).matches
            ? 'auto'
            : 'smooth';
        }

        move(amount) {
          const card = this.track.firstElementChild;

          if (!card) return;

          const gap =
            parseFloat(getComputedStyle(this.track).columnGap) || 0;

          const step = card.getBoundingClientRect().width + gap;

          this.track.scrollBy({
            left: step * amount * this.direction(),
            behavior: this.behavior()
          });
        }

        update() {
          const maximum = this.maximum();
          const position = Math.abs(this.track.scrollLeft);

          this.controls.hidden = maximum <= 2;
          this.previous.disabled = position <= 2;
          this.next.disabled = position >= maximum - 2;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inolyo-avis-photos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('inolyo-reviews')) {
    customElements.define('inolyo-reviews', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.init());
      }

      init() {
        if (!this.isConnected) return;

        this.abort?.abort();
        this.abort = new AbortController();

        const options = { signal: this.abort.signal };

        this.list = this.querySelector('[data-list]');
        this.items = [...this.querySelectorAll('[data-review]')];
        this.sort = this.querySelector('[data-sort]');
        this.rating = this.querySelector('[data-rating]');
        this.onlyPhotos = this.querySelector('[data-only-photos]');
        this.nav = this.querySelector('[data-pagination]');
        this.dialog = this.querySelector('dialog');
        this.page = 1;
        this.pageSize = Math.max(1, Number(this.dataset.pageSize) || 20);

        this.querySelectorAll('[data-controls]').forEach(el => {
          el.hidden = false;
        });

        [this.sort, this.rating, this.onlyPhotos].forEach(el => {
          el.addEventListener('change', () => {
            this.page = 1;
            this.render(true);
          }, options);
        });

        this.addEventListener('click', event => {
          const photo = event.target.closest('[data-photo]');

          if (
            photo &&
            this.contains(photo) &&
            !event.ctrlKey &&
            !event.metaKey &&
            !event.shiftKey
          ) {
            event.preventDefault();
            this.photoTrigger = photo;

            const img = this.querySelector('[data-large-photo]');
            img.src = photo.href;
            img.alt = photo.querySelector('img')?.alt || 'Customer photo';

            this.querySelector('[data-caption-text]').textContent =
              photo.dataset.caption || '';

            if (!this.dialog.open) this.dialog.showModal();
          }

          if (event.target.closest('[data-close]')) {
            this.dialog.close();
          }

          const pageButton = event.target.closest('[data-page]');

          if (pageButton && !pageButton.disabled) {
            this.page = Number(pageButton.dataset.page);
            this.render(true);

            const current = this.nav.querySelector('[aria-current="page"]');
            current?.focus({ preventScroll: true });

            this.scrollIntoView({
              behavior: 'instant',
              block: 'start'
            });
          }
        }, options);

        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;

          const r = this.dialog.getBoundingClientRect();

          if (
            event.clientX < r.left ||
            event.clientX > r.right ||
            event.clientY < r.top ||
            event.clientY > r.bottom
          ) {
            this.dialog.close();
          }
        }, options);

        this.dialog.addEventListener('close', () => {
          this.photoTrigger?.focus({ preventScroll: true });
        }, options);

        this.addEventListener('keydown', event => {
          if (event.key === 'Escape' && !this.dialog.open) {
            this.querySelectorAll('details[open]').forEach(el => {
              el.open = false;
            });
          }
        }, options);

        this.addEventListener('shopify:block:select', event => {
          const item = this.items.find(el =>
            el.dataset.blockId === event.detail?.blockId ||
            el === event.target
          );

          if (!item) return;

          this.rating.value = 'all';
          this.onlyPhotos.checked = false;
          this.render();

          this.page =
            Math.floor(this.filtered.indexOf(item) / this.pageSize) + 1;

          this.render();

          item.scrollIntoView({
            block: 'center',
            behavior: 'instant'
          });
        }, options);

        this.render();
      }

      render(announce = false) {
        const score = this.rating.value;

        this.filtered = this.items.filter(el =>
          (score === 'all' || el.dataset.score === score) &&
          (!this.onlyPhotos.checked || el.dataset.photoCount === '1')
        );

        const date = el => Date.parse(el.dataset.date) || 0;

        this.filtered.sort((a, b) => {
          let diff = 0;

          if (this.sort.value === 'photos') {
            diff = Number(b.dataset.photoCount) -
              Number(a.dataset.photoCount);
          }

          if (this.sort.value === 'newest') {
            diff = date(b) - date(a);
          }

          if (this.sort.value === 'high') {
            diff = Number(b.dataset.score) - Number(a.dataset.score);
          }

          if (this.sort.value === 'low') {
            diff = Number(a.dataset.score) - Number(b.dataset.score);
          }

          return diff ||
            Number(a.dataset.order) - Number(b.dataset.order);
        });

        const pages = Math.ceil(this.filtered.length / this.pageSize);
        this.page = Math.max(1, Math.min(this.page, pages || 1));

        this.items.forEach(el => {
          el.hidden = true;
        });

        this.filtered.forEach((el, index) => {
          this.list.append(el);
          el.hidden =
            index < (this.page - 1) * this.pageSize ||
            index >= this.page * this.pageSize;
        });

        this.querySelector('[data-no-results]').hidden =
          this.filtered.length > 0 || this.items.length === 0;

        this.nav.replaceChildren();
        this.nav.hidden = pages <= 1;

        if (pages > 1) {
          const add = (label, page, disabled, current = false) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.textContent = label;
            button.dataset.page = page;
            button.disabled = disabled;

            button.setAttribute(
              'aria-label',
              label === '‹'
                ? 'Previous page'
                : label === '›'
                  ? 'Next page'
                  : 'Page ' + page
            );

            if (current) button.setAttribute('aria-current', 'page');

            this.nav.append(button);
          };

          add('‹', this.page - 1, this.page === 1);

          for (let i = 1; i <= pages; i++) {
            add(String(i), i, false, i === this.page);
          }

          add('›', this.page + 1, this.page === pages);
        }

        if (announce) {
          this.querySelector('[data-status]').textContent =
            this.filtered.length
              ? this.filtered.length + ' reviews. Page ' +
                this.page + ' of ' + pages + '.'
              : 'No matching reviews.';
        }
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        if (this.dialog?.open) this.dialog.close();
        this.abort?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inolyo-avis-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('inolyo-review-dots')) {
    customElements.define('inolyo-review-dots', class extends HTMLElement {
      connectedCallback() {
        this.startFrame = requestAnimationFrame(() => this.start());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.startFrame);
        cancelAnimationFrame(this.frame);
        this.controller?.abort();
        this.observer?.disconnect();
      }

      start() {
        this.controller?.abort();
        this.observer?.disconnect();

        this.controller = new AbortController();
        const signal = this.controller.signal;

        this.track = this.querySelector('.ir-track');
        if (!this.track) return;

        this.dots = this.querySelector('.ir-dots');
        this.pageKey = '';

        this.querySelectorAll('[data-imported]').forEach(card => {
          card.remove();
        });

        const fragment = document.createDocumentFragment();
        const template = this.querySelector('[data-review-template]');

        (this.querySelector('[data-review-import]')?.value || '')
          .split(/\r?\n/)
          .forEach(line => {
            if (!line.trim()) return;

            const [name, rating, review, image, location] = line
              .split('|')
              .map(value => value.trim());

            const score = Number(rating);

            if (
              !name ||
              !review ||
              !Number.isInteger(score) ||
              score < 1 ||
              score > 5
            ) return;

            const card = template.content.firstElementChild.cloneNode(true);

            card.querySelector('.ir-author').textContent = name;
            card.querySelector('.ir-review').textContent = review;

            card.querySelector('.ir-stars').setAttribute(
              'aria-label',
              this.dataset.starsLabel.replace('__rating__', String(score))
            );

            card.querySelectorAll('.ir-star').forEach((star, i) => {
              star.classList.toggle('ir-star-empty', i >= score);
            });

            if (location) {
              card.querySelector('.ir-location').textContent = location;
              card.querySelector('.ir-location').hidden = false;
            }

            if (image) {
              try {
                const url = new URL(image);

                if (url.protocol === 'https:') {
                  const photo = card.querySelector('img');
                  photo.src = url.href;
                  card.querySelector('.ir-image').hidden = false;

                  photo.addEventListener('error', () => {
                    photo.parentElement.hidden = true;
                  }, { once: true, signal });
                }
              } catch (_) {}
            }

            fragment.append(card);
          });

        this.track.append(fragment);

        this.cards = [...this.track.children];
        this.hidden = !this.cards.length && this.dataset.editor !== 'true';

        this.dots.addEventListener('click', event => {
          const button = event.target.closest('button[data-page]');

          if (button) {
            this.go(this.starts[Number(button.dataset.page)]);
          }
        }, { signal });

        this.track.addEventListener('scroll', () => this.schedule(), {
          passive: true,
          signal
        });

        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;

          if (
            !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)
          ) return;

          event.preventDefault();

          if (event.key === 'Home') {
            this.go(0);
          } else if (event.key === 'End') {
            this.go(this.cards.length - this.columns());
          } else {
            this.move(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, { signal });

        document.addEventListener('shopify:block:select', event => {
          const index = this.cards.findIndex(
            card => card.dataset.blockId === event.detail?.blockId
          );

          if (index !== -1) this.go(index, true);
        }, { signal });

        this.observer = new ResizeObserver(() => this.schedule());
        this.observer.observe(this.track);

        this.update();
      }

      columns() {
        return Number(
          getComputedStyle(this.track).getPropertyValue('--ir-columns')
        ) || 2;
      }

      step() {
        return (
          (this.cards[0]?.getBoundingClientRect().width || 0) +
          (parseFloat(getComputedStyle(this.track).gap) || 0)
        );
      }

      move(direction) {
        this.go(
          Math.round(this.track.scrollLeft / (this.step() || 1)) +
          direction * this.columns()
        );
      }

      go(index, instant = false) {
        const left = Math.max(
          0,
          Math.min(index, this.cards.length - this.columns())
        ) * this.step();

        const reduced = matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches;

        this.track.scrollTo({
          left,
          behavior: instant || reduced ? 'auto' : 'smooth'
        });
      }

      schedule() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }

      update() {
        const columns = this.columns();
        const count = Math.ceil(this.cards.length / columns);
        const key = `${columns}-${this.cards.length}`;

        if (this.pageKey !== key) {
          this.pageKey = key;

          this.starts = Array.from({ length: count }, (_, i) => {
            return Math.max(
              0,
              Math.min(i * columns, this.cards.length - columns)
            );
          });

          const fragment = document.createDocumentFragment();

          this.starts.forEach((_, i) => {
            const button = document.createElement('button');

            button.type = 'button';
            button.className = 'ir-dot';
            button.dataset.page = i;
            button.setAttribute('aria-controls', this.track.id);

            button.setAttribute(
              'aria-label',
              this.dataset.pageLabel.replace('__page__', String(i + 1))
            );

            const dot = document.createElement('span');
            dot.setAttribute('aria-hidden', 'true');

            button.append(dot);
            fragment.append(button);
          });

          this.dots.replaceChildren(fragment);
        }

        this.querySelector('.ir-pagination').hidden = count <= 1;

        const step = this.step();
        let active = 0;

        this.starts.forEach((index, i) => {
          const distance = Math.abs(index * step - this.track.scrollLeft);
          const activeDistance = Math.abs(
            this.starts[active] * step - this.track.scrollLeft
          );

          if (distance < activeDistance) active = i;
        });

        [...this.dots.children].forEach((button, i) => {
          if (i === active) {
            button.setAttribute('aria-current', 'true');
          } else {
            button.removeAttribute('aria-current');
          }
        });

        const selected = this.dots.children[active];

        if (selected) {
          const area = this.dots.getBoundingClientRect();
          const dot = selected.getBoundingClientRect();

          if (dot.left < area.left) {
            this.dots.scrollLeft -= area.left - dot.left;
          }

          if (dot.right > area.right) {
            this.dots.scrollLeft += dot.right - area.right;
          }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inolyo-benefits"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('inolyo-benefits')) {
    customElements.define('inolyo-benefits', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();

        const options = {
          signal: this.controller.signal
        };

        const track = this.querySelector('.inolyo-benefits__track');
        const buttons = [...this.querySelectorAll('[data-direction]')];

        if (!track || !buttons.length) return;

        const rtl = getComputedStyle(track).direction === 'rtl';

        const update = () => {
          const position = Math.abs(track.scrollLeft);

          buttons[0].disabled = position <= 2;
          buttons[1].disabled =
            position >= track.scrollWidth - track.clientWidth - 2;
        };

        const behavior = () =>
          matchMedia('(prefers-reduced-motion: reduce)').matches
            ? 'auto'
            : 'smooth';

        buttons.forEach(button => {
          button.addEventListener('click', () => {
            const card = track.firstElementChild;

            if (!card) return;

            const step =
              card.getBoundingClientRect().width +
              parseFloat(getComputedStyle(track).columnGap);

            track.scrollBy({
              left:
                step *
                Number(button.dataset.direction) *
                (rtl ? -1 : 1),
              behavior: behavior()
            });
          }, options);
        });

        track.addEventListener('scroll', update, {
          ...options,
          passive: true
        });

        document.addEventListener('shopify:block:select', event => {
          if (!(event.target instanceof Element)) return;

          const card = event.target.closest('.inolyo-benefits__card');

          if (!card || !track.contains(card)) return;

          const box = card.getBoundingClientRect();
          const frame = track.getBoundingClientRect();

          track.scrollBy({
            left: rtl
              ? box.right - frame.right
              : box.left - frame.left,
            behavior: 'auto'
          });
        }, options);

        this.observer = new ResizeObserver(update);
        this.observer.observe(track);

        this.classList.add('is-ready');
        update();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inolyo-knee-load"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('inolyo-knee-load')) {
    customElements.define('inolyo-knee-load', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (!this.isConnected) return;

        this.abort?.abort();
        this.abort = new AbortController();

        this.range = this.querySelector('input[type="range"]');
        if (!this.range) return;

        this.unit = this.dataset.unit === 'kg' ? 'kg' : 'lb';
        this.kg = Math.min(
          140,
          Math.max(45, Number(this.dataset.weightKg) || 81)
        );

        const options = { signal: this.abort.signal };

        this.querySelectorAll('[data-unit-button]').forEach(button => {
          button.addEventListener('click', () => {
            this.unit = button.dataset.unitButton;
            this.configure();
            this.announce();
          }, options);
        });

        this.range.addEventListener('input', () => {
          this.kg =
            Number(this.range.value) /
            (this.unit === 'lb' ? 2.2046226218 : 1);

          this.update();
        }, options);

        this.range.addEventListener('change', () => {
          this.announce();
        }, options);

        this.querySelector('.inolyo-load__units').hidden = false;
        this.range.disabled = false;
        this.configure();
      }

      configure() {
        const imperial = this.unit === 'lb';

        this.range.min = imperial ? '99' : '45';
        this.range.max = imperial ? '309' : '140';

        this.range.value = String(
          Math.round(this.kg * (imperial ? 2.2046226218 : 1))
        );

        this.querySelectorAll('[data-unit-button]').forEach(button => {
          button.setAttribute(
            'aria-pressed',
            String(button.dataset.unitButton === this.unit)
          );
        });

        this.update();
      }

      update() {
        const weight = Number(this.range.value);
        const unit = this.unit;
        const forceUnit = unit === 'lb' ? 'lbf' : 'kgf';

        const format = value =>
          new Intl.NumberFormat('en-US', {
            maximumFractionDigits: 0
          }).format(value);

        const percentage =
          (weight - Number(this.range.min)) /
          (Number(this.range.max) - Number(this.range.min)) *
          100;

        this.style.setProperty('--kl-progress', percentage + '%');

        this.querySelector('[data-weight-output]').textContent =
          format(weight);

        this.querySelector('[data-weight-unit]').textContent = unit;

        this.querySelector('[data-min]').textContent =
          this.range.min + ' ' + unit;

        this.querySelector('[data-max]').textContent =
          this.range.max + ' ' + unit;

        this.range.setAttribute(
          'aria-valuetext',
          weight + (unit === 'lb' ? ' pounds' : ' kilograms')
        );

        this.querySelectorAll('[data-factor]').forEach(card => {
          card.querySelector('[data-force]').textContent = format(
            Math.round(weight * Number(card.dataset.factor))
          );
        });

        this.querySelectorAll('[data-force-unit]').forEach(element => {
          element.textContent = forceUnit;
        });

        this.querySelector('[data-banner-force]').textContent =
          format(Math.round(weight * 4.2));
      }

      announce() {
        const weight = this.querySelector(
          '.inolyo-load__weight'
        ).textContent.trim();

        const results = [
          ...this.querySelectorAll('[data-factor]')
        ].map(card =>
          card.querySelector('h3').textContent.trim() +
          ': ' +
          card.querySelector('.inolyo-load__force').textContent.trim()
        );

        this.querySelector('[data-announcement]').textContent =
          weight + '. ' + results.join('. ');
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.abort?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
